// Prius-prime benefits caculator BAT-3173
define('features/vehicle-info/vehicle-benefits-calculator',[
  'jquery',
  'tdaUtils',
  'odometer',
  'disclaimers',
  'responsive',
  'cookies',
  './vehicle-benefits',
  'txt!./vehicle.benefits.calculator.hbs',
  'detectizr',
  'storageUtil',
  'lib/util/zip',
  'zipTools',
  'lib/util/langFromUrl',
  './vehicle-info.prius-prime', // need static disclaimers only from here
  'bat',
  'lib/page-cache',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',

  // side effect includes
  'bxSlider',
  'lib/helpers/replaceDisclaimer',
  'lib/helpers/replace'
], function (
  $,
  tdaUtils,
  Odometer,
  disclaimers,
  responsive,
  cookies,
  VehicleBenefits,
  txtBenefitsCalculator,
  detectizr,
  storageUtil,
  zip,
  zipTools,
  langFromUrl,
  priusPrime,
  bat,
  PageCache,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext
) {
  var __tmplBenefitsCalculator = Handlebars.compile(txtBenefitsCalculator);

  $(window).on('loaded', function () {
    if ($('#benefitsCalculator').length) {
      var self = this;
      self.isIE = detectizr.browser.egine === 'trident';
      var ONE_WAY_COMMUTE = 11.8; // miles
      var EV_RANGE = 25; // miles
      var AVG_GAS_MPG = 26.31;
      var AVG_HYBRID_MPG = 43.92;
      var PRIME_MPG = 54;
      var PRIME_CO2_GPM = 170.9; // CO2 g/mi
      var AVG_GAS_CO2_GPM = 329.14;
      var AVG_HYBRID_CO2_GPM = 206.67;
      var FUEL_PRICE = 2.467;
      var GasPriceData = { 'regionalGasPrices': { 'regions': [{ 'price': '2.319','regionName': 'new-england' },{ 'price': '2.192','regionName': 'lower-atlantic' },{ 'price': '2.338','regionName': 'central-atlantic' },{ 'price': '2.165','regionName': 'mid-west' },{ 'price': '2.088','regionName': 'gulf-coast' },{ 'price': '2.349','regionName': 'rocky-mountain' },{ 'price': '2.525','regionName': 'west-coast-less-california' },{ 'price': '2.846','regionName': 'california' }],'date': '07/25/16' } };
      self._gasPrices = GasPriceData.regionalGasPrices;
      self.defaults = {
        activeClass: 'active',
        chartFillColor: '#d71921',
        chartFillTransition: 'stroke-dashoffset 2s ease-in-out',
        colors: {
          gas: {
            chartBackground: '#fff',
            chartForeground: '#5698fc'
          },
          hybrid: {
            chartBackground: '#003366',
            chartForeground: '#5698fc'
          }
        }
      };

      // GET THE SERIES, PRIMARILY TO GET THE VEHICLE DISCLAIMERS
      self.getSeriesDisclaimers = function () {
        $.ajax({
          type: 'GET',
          contentType: 'application/json',
          dataType: 'json',
          url: '/BATWS/cls/getSeriesTrimInfo.json?brand=toyota&series_code=priusprime&year=2018&key=XLzu5xh4YzCe6LeNpHVG&depth=2'

        }).done(function (response) {
          var tempDisclaimersObj = response.series.disclaimers;
          var finalDisclaimersObj = {};
          // We are missing these disclaimers
          var primeGasObj = { code: 'prime_gas', text: 'You should never drive Prius Prime without gasoline in the tank. While, under certain conditions, you may drive on electricity alone, the vehicle always requires gasoline to operate properly. The <i>Owner:&amp;s Manual</i> recommends a 1/4 tank. In some instances, even with a charge, the engine could turn on. Calculations assume you begin your commute with a full battery charge.' };
          var primeTCOObj = { code: 'prime_tco_doesource', text: 'Competitive set based on average midsize competitive vehicles, with a 2017 EPA-estimated midsize sedan vehicle average of 26.31 mpg (midsize sedan vehicle average includes Ford Fusion, Hyundai Sonata, Toyota Camry, Honda Accord, Kia Optima, Nissan Altima, Chevrolet Malibu, Chevrolet Impala) and a 2017 EPA-estimated midsize hybrid vehicle average of 43.92 mpg (midsize hybrid vehicle average includes Ford Fusion Hybrid, Hyundai Sonata Hybrid, Toyota Prius, Toyota Camry Hybrid, Honda Accord Hybrid, Kia Optima Hybrid, Ford C-Max Hybrid, Toyota Prius v, Chevrolet Malibu Hybrid). For more information, visit <a href="http://www.fueleconomy.gov/feg/download.shtml" target="_blank" data-di-id="#http://www.fueleconomy.gov/feg/download.shtml-2">www.fueleconomy.gov/feg/download.shtml</a>' };
          if (langFromUrl() === 'es') {
            primeGasObj = { code: 'prime_gas', text: 'Nunca deberías manejar el Prius Prime sin gasolina en el tanque. Aunque puedes manejar solamente con electricidad bajo ciertas circunstancias, el vehículo siempre necesita gasolina para funcionar correctamente. El Manual del Propietario recomienda tener un 1/4 de tanque. En algunas instancias, incluso teniendo recarga, el motor podría encenderse.' };
            primeTCOObj = { code: 'prime_tco_doesource', text: 'Las comparaciones están basadas en la competitividad promedio para autos medianos, con un estimado de la EPA en 2017 para sedán mediano con un promedio de 26.31 mpg (el promedio para sedán mediano incluye Ford Fusion, Hyundai Sonata, Toyota Camry, Honda Accord, Kia Optima, Nissan Altima, Chevrolet Malibu, Chevrolet Impala) y un estimado de la EPA en 2017 para vehículos híbridos medianos con un promedio de 43.92 mpg (vehículos híbridos medianos incluye Ford Fusion Hybrid, Hyundai Sonata Hybrid, Toyota Prius, Toyota Camry Hybrid, Honda Accord Hybrid, Kia Optima Hybrid, Ford C-Max Hybrid, Toyota Prius v, Chevrolet Malibu Hybrid). Para más información, por favor visita <a href="http://www.fueleconomy.gov/feg/download.shtml" target="_blank" data-di-id="#http://www.fueleconomy.gov/feg/download.shtml-2">www.fueleconomy.gov/feg/download.shtml</a>.' };
          }
          tempDisclaimersObj.push(primeGasObj, primeTCOObj);

          if (tempDisclaimersObj !== null) {
            for (var i = 0; i < tempDisclaimersObj.length; i++) {
              finalDisclaimersObj[tempDisclaimersObj[i].code] = {
                code: tempDisclaimersObj[i].code,
                description: tempDisclaimersObj[i].text
              };
            }
          }
          self.cachedDisclaimerMap = finalDisclaimersObj;
          var moreLocalDisclaimers = finalDisclaimersObj;

          disclaimers.createDisclaimerCache();
          disclaimers.addLocalDisclaimers();

          var newDisclaimers = [];
          $.each(priusPrime.staticDisclaimers, function (idx, disclaimer) {
            if (moreLocalDisclaimers[disclaimer]) {
              // Rejoice in this glory.
              if (disclaimer === 'prime_2018_range_rating') {
                newDisclaimers.push({
                  service_id: moreLocalDisclaimers.prime_2018_range_rating.code,
                  disclaimer_copy: 'Based on 2018 Prius Prime EPA-estimated combined 133 MPGe, and non-luxury plug-in hybrid segment from <a href="https://www.fueleconomy.gov" target="_blank">www.fueleconomy.gov</a>. Actual mileage will vary.'
                });
              } else if (disclaimer === 'prime_2018_ev_range') {
                newDisclaimers.push({
                  service_id: moreLocalDisclaimers.prime_2018_ev_range.code,
                  disclaimer_copy: '2018 Prius Prime EPA-estimated range rating when fully charged and with a full tank of gas. Excludes driving conditions. Actual mileage will vary.'
                });
              } else {
                newDisclaimers.push({
                  service_id: moreLocalDisclaimers[disclaimer].code,
                  disclaimer_copy: moreLocalDisclaimers[disclaimer].description
                });
              }
            }
          });
          disclaimers.addVehicleInfoDisclaimers(newDisclaimers);

          /*
          at times, we need to ensure disclaimers are ready before
          we try to draw them (prius-prime, benefits page)
          add them to PageCache simply to provide something we can listen to
          */
          var cacheId = 'vehicle.info.localDisclaimers';
          if (!PageCache.has(cacheId) && !PageCache.isPending(cacheId)) {
            PageCache.set(cacheId, moreLocalDisclaimers);
          }
        });
      };
      self.getSeriesDisclaimers();

      self.initCharts = function () {
        var self = this;
        self.dollarsOdometer = new Odometer({
          el: self.$dollarsOdometer[0],
          value: 0,
          // github.com/HubSpot/odometer/issues/91#issuecomment-88532985
          // duration: self.options.duration // not what you think...
          duration: 2000
        });

        self.gallonsOdometer = new Odometer({
          el: self.$gallonsOdometer[0],
          value: 0,
          duration: 2000
        });

        self.emissionsOdometer = new Odometer({
          el: self.$emissionsOdometer[0],
          value: 0,
          duration: 2000
        });

        self.milesOdometer = new Odometer({
          el: self.$milesOdometer[0],
          value: 0,
          duration: 2000
        });
      };

      // CALCULATIONS
      // [Annual Commute Total] = [Daily Commute Total] x 5 days a week x 50 weeks per year
      self._calcAnnualCommute = function (dailyCommute) {
        var val = (dailyCommute * 5) * 50;
        // console.log('ANNUAL COMMUTE', val);
        return val;
      };

      /*
      Use case if [Daily Commute Total] is less than or equal to 22 miles, with or without workplace charging
      If [Daily Commute Total] < 22 miles
      [Annual EV Total] = [Daily Commute Total] x 5 x 50 = [Annual Commute Total]

      Use case if [Daily Commute Total] is greater than or equal to 22 miles and without workplace charging
      If [Daily Commute Total] > 22 & [Workplace Charging] = false
      [Annual EV Total] = 22 x 5 x 50 = 5,500

      Use case if [user input] is greater than or equal to 22 miles and with workplace charging
      If [user input] > 22 & [Workplace Charging] = true
      [Annual EV Total] = 44 x 5 x 50 = 11,000
      */
      self._calcAnnualEvCommute = function (dailyCommute) {
        var self = this;
        var charging = self._values.haveCharging;

        if (dailyCommute <= EV_RANGE) {
          // [Annual EV Total] = [Daily Commute Total] x 5 x 50 = [Annual Commute Total]
          return self._calcAnnualCommute(dailyCommute);
        }

        if (dailyCommute > EV_RANGE && charging === false) {
          // [Annual EV Total] = 22 x 5 x 50 = 5,500
          return self._calcAnnualCommute(EV_RANGE);
        }

        if (dailyCommute > EV_RANGE && charging === true) {
          // [Annual EV Total] = 44 x 5 x 50 = 11,000
          return self._calcAnnualCommute(EV_RANGE * 2);
        }
      };

      // [Annual Gas Commute Total] = [Annual Commute Total] – [Annual EV Commute Total]
      self._calcAnnualGasCommute = function (dailyCommute) {
        var self = this;
        var val = self._calcAnnualCommute(dailyCommute) - self._calcAnnualEvCommute(dailyCommute);

        // console.log('ANNUAL GAS COMMUTE', val);

        return val;
      };

      // [Annual Commute Total] ÷ [Average Gas MPG]
      self._calcAvgGasFuelConsumption = function (dailyCommute) {
        var self = this;
        var val = self._calcAnnualCommute(dailyCommute) / AVG_GAS_MPG;

        // console.log('AVG GAS FUEL CONSUMPTION', val);

        return val;
      };

      // [Annual Commute Total] ÷ [Average Hybrid MPG]
      self._calcAvgHybridFuelConsumption = function (dailyCommute) {
        var self = this;
        var val = self._calcAnnualCommute(dailyCommute) / AVG_HYBRID_MPG;

        // console.log('AVG HYBRID FUEL CONSUMPTION', val);

        return val;
      };

      // [Prius Prime Fuel Consumption] = [[Annual Commute total] – [Annual EV Total]] ÷ [Prius Prime MPG]
      self._calcPrimeGasFuelConsumption = function (dailyCommute) {
        var self = this;
        var val = (self._calcAnnualCommute(dailyCommute) - self._calcAnnualEvCommute(dailyCommute)) / PRIME_MPG;

        if (val < 0) {
          val = 0;
        }
        return val;
      };

      // [Prius Prime CO2 Emissions] = [Prius Prime co2TailpipeGpm] x [Annual Gas Commute Total
      self._calcPrimeCo2Emissions = function (dailyCommute) {
        var self = this;
        var val = PRIME_CO2_GPM * self._calcAnnualGasCommute(dailyCommute);
        return val;
      };

      // [AVG Gas co2TailpipeGpm] x [Annual Commute Total]
      self._calcAvgGasCo2Emissions = function (dailyCommute) {
        var self = this;
        var val = AVG_GAS_CO2_GPM * self._calcAnnualCommute(dailyCommute);
        return val;
      };

      // [AVG Hybrid co2TailpipeGpm] x [Annual Commute Total]
      self._calcAvgHybridCo2Emissions = function (dailyCommute) {
        var self = this;
        var val = AVG_HYBRID_CO2_GPM * self._calcAnnualCommute(dailyCommute);
        return val;
      };

      // [Gallons of Gas Saved] = [DOT Gas Fuel Consumption] – [Prius Prime Gas Fuel Consumption]
      self._gallonsSaved = function (dailyCommute) {
        var self = this;
        var val;

        if (self._values.vehicleType === 'gas') {
          val = self._calcAvgGasFuelConsumption(dailyCommute) - self._calcPrimeGasFuelConsumption(dailyCommute);
        } else {
          val = self._calcAvgHybridFuelConsumption(dailyCommute) - self._calcPrimeGasFuelConsumption(dailyCommute);
        }
        // console.log('GALLONS SAVED');
        // console.log('self._calcDotGasFuelConsumption(dailyCommute)', self._calcDotGasFuelConsumption(dailyCommute));
        // console.log('self._calcPrimeGasFuelConsumption(dailyCommute)', self._calcPrimeGasFuelConsumption(dailyCommute));
        return val;
      };

      // [Annual Percentage of Miles Driven in Electric] = [Annual EV Commute Total] ÷ [Annual Commute Total]
      self._milesDriven = function (dailyCommute) {
        var self = this;
        var val = (self._calcAnnualEvCommute(dailyCommute) / self._calcAnnualCommute(dailyCommute)) * 100;

        if (val > 100) {
          val = 100;
        }

        // console.log('MILES DRIVEN');
        // console.log('self._calcAnnualEvCommute(dailyCommute)', self._calcAnnualEvCommute(dailyCommute));
        // console.log('self._calcAnnualCommute(dailyCommute)', self._calcAnnualCommute(dailyCommute));

        return val;
      };

      // 1 – [[Prius Prime CO2 Emissions] ÷ [DOT CO2 Emissions]]
      self._emissionsReduced = function (dailyCommute) {
        var self = this;
        var val;

        if (self._values.vehicleType === 'gas') {
          val = (1 - (self._calcPrimeCo2Emissions(dailyCommute) / self._calcAvgGasCo2Emissions(dailyCommute))) * 100;
        } else {
          val = (1 - (self._calcPrimeCo2Emissions(dailyCommute) / self._calcAvgHybridCo2Emissions(dailyCommute))) * 100;
        }

        if (val > 100) {
          val = 100;
        }

        // console.log('EMISSIONS REDCED');
        // console.log('self._calcPrimeCo2Emissions(dailyCommute)', self._calcPrimeCo2Emissions(dailyCommute));
        // console.log('self._calcDotCo2Emissions(dailyCommute)', self._calcDotCo2Emissions(dailyCommute));

        return val;
      };

      // [Dollars Saved on Fuel] = [Gallons of Gas Saved] x [Fuel Price]
      self._dollarsSaved = function (gallonsSaved) {
        var price;
        var val;
        price = self._gasPrice;
        val = gallonsSaved * price;
        return val;
      };

      self.getGasPriceByRegion = function (regionName) {
        var regions;
        var item;

        if (!this._gasPrices.regions) {
          return;
        }

        regions = this._gasPrices.regions;

        for (var i = 0, len = regions.length; i < len; i += 1) {
          item = regions[i];

          if (item.regionName && item.regionName === regionName) {
            return item.price;
          }
        }

        return; // if it gets here the region wasn't found to return undefined
      };

      self.getGasPrice = function () {
        var self = this;
        var dfd = $.Deferred();
        var nationalPrice = self.getGasPriceByRegion('national') || FUEL_PRICE;
        var region;
        var regionPrice;

        var stateAbbr = tdaUtils.getStateAbbr(unescape(storageUtil.getState()));
        // self._getState().done(function(state) {
        // cache the default price as fallback
        self._gasPrice = nationalPrice;
        if (!stateAbbr) {
          // then use the default gas price
          dfd.resolve(nationalPrice);
        }

        // we have a state so get the region
        region = tdaUtils.getRegion(stateAbbr);

        // if no state/region match then use the default price
        if (!region) {
          dfd.resolve(nationalPrice);
        }

        regionPrice = self.getGasPriceByRegion(region);
        if (regionPrice) {
          // update cache with the found price
          self._gasPrice = regionPrice;

          dfd.resolve(regionPrice);
        }

        // finally, if no region price was found then use the national price
        dfd.resolve(nationalPrice);
        // });

        return dfd.promise();
      };
      // CHART DISPLAY UPDATES:
      self.updateDollarsChart = function (data) {
        data || (data = this._lastDollarsData);
        this._lastDollarsData = data;

        var self = this;
        var bgPath = self.$('.path-circle-chart-1')[0];
        var path = self.$('.path-circle-chart-2')[0];
        var length = path.getTotalLength();
        var dec = data.savings / data.avg;
        var fill = Math.floor(length - (length * dec));
        var bgColor;
        var avgLabel;

        // first reset the chart
        self.fillPath(path, length, length);
        self.dollarsOdometer.update(0);

        // then update
        if (self._vehicleType === 'hybrid') {
          bgColor = '#434343';
          avgLabel = 'Average hybrid vehicle';
        } else {
          bgColor = '#434343';
          avgLabel = 'Average gas vehicle';
        }

        self.fillPath(bgPath, 0, 0, bgColor);
        self.fillPath(path, length, fill, self.defaults.chartFillColor);
        self.$primeDollarsValue.text('$' + data.prime.toLocaleString());
        self.$avgDollarsValue.text('$' + data.avg.toLocaleString());
        self.$avgDollarsLabel.html(avgLabel);
        self.dollarsOdometer.update(data.savings);
      };

      /**
         * Data Format
         * {
                avg: 611,
                prime: 225,
                savings: 386
            }
         */
      self.updateGallonsChart = function (data) {
        var self = this;
        var pct = ((data.savings / data.avg) * 100) * -1; // reverse the amount and make it negative
        var $avgTriangle = self.$('.chart-avg-gallons');
        var $avgTriangleSVG = $avgTriangle.find('polygon');
        var triangleFill;
        var avgLabel;

        // first reset the chart
        self.$line.css({
          transition: 'none',
          width: '0'
        });
        self.$primeTriangle.css({
          transition: 'none',
          bottom: '-100%'
        });
        self.$avgTriangle.css({
          transition: 'none',
          bottom: '-100%'
        });

        self.$primeTriangle[0].offsetHeight;
        self.$avgTriangle[0].offsetHeight;

        self.gallonsOdometer.update(0);

        // then update
        if (self._vehicleType === 'hybrid') {
          triangleFill = '#003399';
          avgLabel = 'Average hybrid vehicle';
        } else {
          triangleFill = '#434343';
          avgLabel = 'Average gas vehicle';
        }

        $avgTriangleSVG.css('fill', triangleFill);
        self.$primeGallonsValue.text(data.prime.toLocaleString() + ' Gal.');
        self.$avgGallonsValue.text(data.avg.toLocaleString() + ' Gal.');
        self.$avgGallonsLabel.html(avgLabel);

        self.$line.css({
          transition: 'width 1s ease-in-out',
          'transition-delay': '1s',
          width: '100%'
        });
        self.$primeTriangle.css({
          transition: 'bottom 2s ease-in-out',
          bottom: pct
        });
        self.$avgTriangle.css({
          transition: 'bottom 2s ease-in-out',
          bottom: 0
        });
        self.gallonsOdometer.update(data.savings);
      };

      self.updateEmissionsChart = function (value) {
        var self = this;
        var bgPath1 = self.$('.emissions-car-wavy-1')[0];
        var bgPath2 = self.$('.emissions-car-wavy-1a')[0];
        var path1 = self.$('.emissions-car-wavy-3')[0];
        var path2 = self.$('.emissions-car-wavy-4')[0];
        var length = path1.getTotalLength();
        var dec = value / 100;
        var fill = Math.floor(length - (length * dec))
        var bgColor;

        // first reset the chart
        self.fillPath(path1, length, length);
        self.fillPath(path2, length, length);
        self.emissionsOdometer.update(0);

        // then update
        if (self._vehicleType === 'hybrid') {
          bgColor = '#003399';
        } else {
          bgColor = '#fff';
        }

        self.fillPath(bgPath1, 0, 0, bgColor); // background path
        self.fillPath(bgPath2, 0, 0, bgColor); // background path

        self.fillPath(path1, length, fill, self.defaults.chartFillColor);
        self.fillPath(path2, length, fill, self.defaults.chartFillColor);
        self.emissionsOdometer.update(value);
      };

      self.updateMilesChart = function (value) {
        var self = this;
        var isCarousel = responsive() === 'sm';// /phone|phablet/.test(viewport.getCurrentQuery()), TODO:fix
        var selectorParent = isCarousel ? '.carousel-graphic' : '.layout-graphic';
        var bgPath = self.$(selectorParent + ' .path-distance-2')[0];
        var path = self.$(selectorParent + ' .path-distance-4')[0];
        var length = path.getTotalLength();
        var dec = value / 100;
        var fill = Math.floor(length - (length * dec));
        var bgColor;

        // first reset the chart
        self.fillPath(path, length, length);
        self.milesOdometer.update(0);

        // then update
        if (self._vehicleType === 'hybrid') {
          bgColor = '#434343';
        } else {
          bgColor = '#434343';
        }
        self.fillPath(bgPath, 0, 0, bgColor); // background path
        self.fillPath(path, length, fill, self.defaults.chartFillColor);
        self.milesOdometer.update(value);
      };

      self.fillPath = function (path, length, fill, color) {
        var self = this;

        // Clear any previous transition
        path.style.transition = path.style.WebkitTransition = 'none';

        // Set up the starting positions
        path.style.strokeDasharray = length + ' ' + length;
        path.style.strokeDashoffset = length;

        // Trigger a layout so styles are calculated & the browser
        // picks up the starting position before animating
        path.getBoundingClientRect();

        path.style.stroke = color;

        // Define our transition
        if (!self.isIE) {
          path.style.transition = path.style.WebkitTransition = self.defaults.chartFillTransition;
        }

        // start it
        path.style.strokeDashoffset = fill;

        if (self.isIE) {
          // Trigger a layout so styles are calculated & the browser
          // picks up the starting position before animating
          path.getBoundingClientRect();
        }
      };

      self.animate = function (delay) {
        var self = this;

        delay || (delay = 0);

        if (self._hasAnimated) {
          return;
        }
        self._hasAnimated = true;
      };

      self.updateChartDisplay = function (data, vehicleType) { // this was 'updateChars' from tco-charts-panel.
        var self = this;
        self._data = data;
        self._vehicleType = vehicleType;

        if (data) {
          self.updateDollarsChart(data.dollars);
          self.updateGallonsChart(data.gallons);
          self.updateEmissionsChart(data.emissions);
          self.updateMilesChart(data.miles);
        }
      };


      self.updateCharts = function () { // update charts from tco-full-panel.js
        var self = this;
        var dailyCommute;
        var gallonsAvg;
        var gallonsPrime;
        var gallonsSaved;
        var dollarsSaved;
        var dollarsAvg;
        var dollarsPrime;
        var milesDriven;
        var emissionsReduced;


        self._modalOpen && self.modal.close();
        dailyCommute = self._values.dailyCommute;

        if (self._values.vehicleType === 'gas') {
          gallonsAvg = self._calcAvgGasFuelConsumption(dailyCommute);
        } else {
          gallonsAvg = self._calcAvgHybridFuelConsumption(dailyCommute);
        }

        gallonsPrime = self._calcPrimeGasFuelConsumption(dailyCommute);
        gallonsSaved = self._gallonsSaved(dailyCommute);

        dollarsAvg = gallonsAvg * self._gasPrice;
        dollarsPrime = gallonsPrime * self._gasPrice;
        dollarsSaved = self._dollarsSaved(gallonsSaved);

        emissionsReduced = self._emissionsReduced(dailyCommute);

        milesDriven = self._milesDriven(dailyCommute);


        var valuesObj = {
          dollars: {
            avg: Math.floor(dollarsAvg),
            prime: Math.floor(dollarsPrime),
            savings: Math.floor(dollarsSaved)
          },
          gallons: {
            avg: Math.floor(gallonsAvg),
            prime: Math.floor(gallonsPrime),
            savings: Math.floor(gallonsSaved)
          },
          emissions: Math.floor(emissionsReduced),
          miles: Math.floor(milesDriven)
        };

        self.updateChartDisplay(valuesObj, self._values.vehicleType);
      };

      self.prepareCharts = function () {
        var self = this;

        self._values.vehicleType = self.$('#vehicleType').val();

        self.getGasPrice().done(function () {
          setTimeout(function () {
            self.updateCharts();
          }, 250);
        });
      };

      self.toggleTooltip = function ($el) {
        var self = this;
        var activeClass = 'active';// self.options.activeClass,
        var tooltipId = $el.data('tooltipId');

        // if a different tooltip was opened then close the others
        if (self._openTooltip && self._openTooltip !== tooltipId) {
          self.hideTooltips();
        }

        if ($el.hasClass(activeClass)) {
          $el.removeClass(activeClass);

          self._openTooltip = undefined;
        } else {
          $el.addClass(activeClass);
          self._openTooltip = tooltipId;
        }
      };

      self.hideTooltips = function () {
        var self = this;

        if (!self._openTooltip) {
          return;
        }

        self.$('.info-tooltip').removeClass('active');
        self._openTooltip = undefined;
      };

      // Get benefits and create benefits modal
      var vehicleBenefits = new VehicleBenefits();
      vehicleBenefits.init();

      var incentivesReq = vehicleBenefits.getContent('PriusPrimeIncentives');
      incentivesReq.done(function (incentiveResponse) {
        // vehicle-info shares a similar pattern to this:
        var benefitObj = {};
        benefitObj.federal = incentiveResponse.national;
        benefitObj.state = incentiveResponse.state;

        // GET CALCULATOR PAGE CONTENT:
        var pageContent = vehicleBenefits.getContent('PriusPrimeTCO');
        pageContent.done(function (response) {
          response.benefitObj = benefitObj;
          response.toggle.largeDeviceCopy = response.toggle.largeDeviceCopy.replace('&lt;br&gt;', ' ');// REMOVE LINE BREAK.
          response.calculator.disclaimer = $.parseHTML(response.calculator.disclaimer)[0].textContent;
          response.tagline = $.parseHTML(response.tagline)[0].textContent;
          response.milesChart.tooltip.copy = $.parseHTML(response.milesChart.tooltip.copy)[0].textContent;
          response.emissionsChart.tooltip.copy = $.parseHTML(response.emissionsChart.tooltip.copy)[0].textContent;
          response.emissionsChart.tooltip.smallCopy = $.parseHTML(response.emissionsChart.tooltip.smallCopy)[0].textContent;
          response.milesChart.tooltip.copy = $.parseHTML(response.milesChart.tooltip.copy)[0].textContent;
          response.gallonsChart.tooltip.copy = $.parseHTML(response.gallonsChart.tooltip.copy)[0].textContent;
          response.gallonsChart.tooltip.smallCopy = $.parseHTML(response.gallonsChart.tooltip.smallCopy)[0].textContent;

          // We have all the things we need to draw the results
          var calculatorlHtml = __tmplBenefitsCalculator({ data: response });
          $('#js-template-benefits-calculator-output').html(calculatorlHtml);
          PageCache.await('vehicle.info.localDisclaimers')
            .then(function () {
              disclaimers.updateBenefitsDisclaimers('#template-benefits');
              disclaimers.msrpMpgDigits('.vehicle-benefits-calculator-top');
            });

          // useful selectors.
          self.$dollarsOdometer = self.$('.dollars-odometer');
          self.$gallonsOdometer = self.$('.gallons-odometer');
          self.$emissionsOdometer = self.$('.emissions-odometer');
          self.$milesOdometer = self.$('.miles-odometer');

          self.$primeDollarsValue = self.$('.prime-dollars .value');
          self.$avgDollarsValue = self.$('.avg-dollars .value');
          self.$avgDollarsLabel = self.$('.avg-dollars .label');

          self.$primeGallonsValue = self.$('.prime-gallons .value');
          self.$avgGallonsValue = self.$('.avg-gallons .value');
          self.$avgGallonsLabel = self.$('.avg-gallons .label');
          self.$line = self.$('.line');
          self.$primeTriangle = self.$('.chart-prime-gallons');
          self.$avgTriangle = self.$('.chart-avg-gallons');

          self.$odomoters = self.$('.odometer');
          self.$tooltips = self.$('.info-tooltip');

          // DEFAULT VALUES
          self._values = {
            haveCharging: false,
            startVal: '',
            destVal: ''
          };

          self._openTooltip = undefined;

          var zipCode = zip.getCookiedDefaultFallback();
          if (storageUtil.getTDA() === 'WWW') {
            $('.incentives-and-savings .container .header p').text('...');
            var lang = storageUtil.getLangFromUrl();
            var ctaText = lang === 'en' ? 'Set Your Location' : 'Establece tu ubicaci&#x00F3;n';
            var linkString = '<a id="locationChange" class="location-change js-nav-zip" href="#location">' + ctaText + '</a>';

            setTimeout(function () {
              $('.incentives-and-savings .container .header p').html(linkString);
              $('#locationChange')
                .on('click', function (e) {
                  e.preventDefault();
                  var redirectHref = window.location.pathname;
                  zipTools.showPromptUserZipModal(zipCode, zipCode, redirectHref, '', true, true);
                });
            }, 0);
          } else {
            $('#locationChange').text(zipCode).on('click', function (e) {
              var redirectHref = window.location.pathname;
              e.preventDefault();
              zipTools.showPromptUserZipModal(zipCode, zipCode, redirectHref, '', true, true);
            });
          }

          // SUBMISSION BTN CLICKS.
          $('#benefitsCalcSubmitMob').on('click', function (evt) {
            window.bat.util.loader.showLoader();
            evt.preventDefault();
            var startVal = $('#homeAddressMob').val();// 'Dedham Parkway, Boston, MA 02026, United States';
            var endVal = $('#workAddressMob').val();// '1605 VFW Parkway Boston, MA 02132';
            vehicleBenefits.requestDistance(startVal, endVal, self.handleResponse);
          });

          $('#benefitsCalcSubmit, #benefitsCalcSubmitMob').on('click', function (evt) {
            window.bat.util.loader.showLoader();
            evt.preventDefault();
            var startVal = $('#homeAddress').val();// 'Dedham Parkway, Boston, MA 02026, United States';
            var endVal = $('#workAddress').val();// '1605 VFW Parkway Boston, MA 02132';
            vehicleBenefits.requestDistance(startVal, endVal, self.handleResponse);
          });

          $('.personalize').on('click', function () {
            $('.personalize').toggleClass('active');
            $('.calc-inner').toggleClass('active');
          });

          $('.info-tooltip').on('click', function (evt) {
            var $currentTarget = $(evt.currentTarget);
            var $target = $(evt.target);

            if ((!$target.is('a') && !$target.is('sup')) || ($target.is('a') && $target.hasClass('info-tooltip'))) {
              self.toggleTooltip($currentTarget);
              evt.preventDefault();
              evt.stopPropagation();
            }
          });
          self.initCharts();
          $('#distanceCalcForm').h5Validate();
          $('#distanceCalcFormMob').h5Validate();

          // ADD DATALAYER CONTEXT
          var $mainCtx = $('#benefitsCalculator');
          anAddContext(
            $mainCtx,
            blocks.sectionBlock('Benefits Calculator'),
            blocks.seriesBlock({
              series_code: 'priusprime',
              year: '2018'
            })
          );
          anClicks($mainCtx);
          anPageLoad($mainCtx);

          // VALIDITY CHECKS:
          $('#homeAddress, #workAddress').keyup(function () {
            $('.error-copy').removeClass('show');
            var valid = $('#distanceCalcForm').h5Validate('allValid');
            if (valid) {
              $('#benefitsCalcSubmit').removeClass('disabled');
            } else {
              $('#benefitsCalcSubmit').addClass('disabled');
            }
          });

          $('#homeAddressMob, #workAddressMob').keyup(function () {
            $('.error-copy-mob').removeClass('show');
            var valid = $('#distanceCalcFormMob').h5Validate('allValid');
            if (valid) {
              $('#benefitsCalcSubmitMob').removeClass('disabled');
            } else {
              $('#benefitsCalcSubmitMob').addClass('disabled');
            }
          });

          self.processDistanceResponse = function (distance) {
            self._values.dailyCommute = distance * 2;
            $('#roundTripDisplay').text(self._values.dailyCommute.toFixed(2) + ' miles');

            var offset = $('.vehicle-benefits-calculator-form').offset().top;// - headerHeight;
            offset -= 57;// FOR HEADER NAV.

            var delay = responsive() === 'sm' ? 500 : 200;
            if (responsive() === 'sm') {
              offset = $('.tco-charts').offset().top;
            }

            setTimeout(function () {
              $('html, body').animate({
                scrollTop: offset
              }, 500)
                .promise()
                .done(function () {
                  setTimeout(function () {
                    self.prepareCharts();
                    self._defaultState = false;
                  }, 600);
                });
            }, delay);
          };

          self.handleResponse = function (response, status) {
            var self = this;
            var distance;
            bat.util.loader.hideLoader(null, true, 250);
            var rowStatus = response.rows[0].elements[0].status;
            if (status === 'OK' && (!/NOT_FOUND|ZERO_RESULTS/.test(rowStatus))) {
              distance = response.rows[0].elements[0].distance.value * 0.00062137; // convert meters to miles
              var startVal = responsive() === 'sm' ? $('#homeAddressMob').val() : $('#homeAddress').val();
              var endVal = responsive() === 'sm' ? $('#workAddressMob').val() : $('#workAddress').val();
              var tomorrow = new Date((new Date()).valueOf() + 1000 * 3600 * 24);
              cookies.setItem('benfitsStartAddress', startVal, tomorrow, '/', cookies.getCrossDomainCookieDomain());
              cookies.setItem('benfitsEndAddress', endVal, tomorrow, '/', cookies.getCrossDomainCookieDomain());
              cookies.setItem('benfitsTripDistance', distance, tomorrow, '/', cookies.getCrossDomainCookieDomain());
              self.processDistanceResponse(distance);
            } else {
              if (responsive() === 'sm') {
                $('.error-copy-mob').addClass('show');
                $('#homeAddressMob').val('');
                $('#workAddressMob').val('');
              } else {
                $('.error-copy').addClass('show');
                $('#homeAddress').val('');
                $('#workAddress').val('');
              }
            }
          };
          // template has been drawn, initialize.
          if (cookies.getItem('benfitsStartAddress')) { // benfitsStartAddress
            var distance = Number(cookies.getItem('benfitsTripDistance'));
            $('#homeAddress').val(cookies.getItem('benfitsStartAddress'));
            $('#workAddress').val(cookies.getItem('benfitsEndAddress'));
            $('#homeAddressMob').val(cookies.getItem('benfitsStartAddress'));
            $('#workAddressMob').val(cookies.getItem('benfitsEndAddress'));
            $('#benefitsCalcSubmit').removeClass('disabled');
            $('#benefitsCalcSubmitMob').removeClass('disabled');
            self.processDistanceResponse(distance);
          }

          // CAROUSEL
          var slider = false;

          function showCarousel() {
            if (slider !== false) return;
            slider = $('.tcom-carousel').bxSlider({
              controls: false,
              useCSS: false,
              infiniteLoop: false,
              slideWidth: $('.dollars-slide').width(),
              onSliderLoad: function () {
                $('.tco-charts .bx-prev,.tco-charts .bx-next').hide();
              },
              onSlideBefore: function ($el, prevIdx, nextIdx) {
                if (!self._data) {
                  return;
                }
                switch (nextIdx) {
                  case 0: self.updateDollarsChart(self._data.dollars); break;
                  case 1: self.updateGallonsChart(self._data.gallons); break;
                  case 2: self.updateEmissionsChart(self._data.emissions); break;
                  case 3: self.updateMilesChart(self._data.miles); break;
                  default: break;
                }
              },
            });
          }

          function hideCarousel() {
            if (slider == false) return;
            slider.destroySlider();
            slider = false;
          }

          $(window).on('breakpoint', function () {
            // Our breakpoint has changed... update the carousel appropriately
            if (responsive() === 'sm') {
              // Only show the carousel on small
              showCarousel();
            } else {
              hideCarousel();
            }
          });

          if (responsive() === 'sm') {
            showCarousel();
          }

          // END CAROUSEL.

          // SHOW STATE BENEFITS MODAL:
          $('#stateIncentives').on('click', function (e) {
            e.preventDefault();
            $('#modal-benefits').modal('show');
          });

          var dk_vehicleType = $('#vehicleType').dropkick({ mobile: true });
          dk_vehicleType.change(function () {
            // CLEAR INPUT VAL.
            self._values.vehicleType = $(this).val();
            // self.updateChartDisplay(self._data, vehicleType);
            self.updateCharts();
          });
          vehicleBenefits.createBenefitsModal('#js-template-benefits-modal-output');
        });
      });
    }
  });
});

